import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';

// axios.defaults.baseURL = 'http://localhost:8000';
axios.defaults.baseURL = 'https://e-meeting.wanorn.com/backend/';
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
axios.defaults.withCredentials = true;

// Import custom CSS
import './assets/main.css';
// Import Bootstrap Icons CSS
// import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap-icons/font/bootstrap-icons.css';

import SmartTable from 'vuejs-smart-table'

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

createApp(App)
    .component('v-select', vSelect)
    .component('VueDatePicker', VueDatePicker)
    .use(SmartTable)
    .use(store)
    .use(router)
    .mount('#app')

document.body.classList.add('app', 'sidebar');

